module.exports = {
  initAnnualReviewSlider: () => {
    const switchYearBtns = document.querySelectorAll('.switch-year-btn')
    const sliders = document.querySelectorAll('[data-slider-year]')

    for (const el of switchYearBtns) {
      const year = el.getAttribute('data-year')

      const activeClass = 'bg-blue-500 text-white'
      const unactiveClass = 'text-blue-500 hover:bg-blue-500 hover:text-white'

      el.addEventListener('click', () => {
        for (const btnEl of switchYearBtns) {
          if (el.isEqualNode(btnEl)) {
            activeClass.split(' ').forEach(className => btnEl.classList.add(className))
            unactiveClass.split(' ').forEach(className => btnEl.classList.remove(className))
          } else {
            activeClass.split(' ').forEach(className => btnEl.classList.remove(className))
            unactiveClass.split(' ').forEach(className => btnEl.classList.add(className))
          }
        }

        for (const sliderEl of sliders) {
          const sliderYear = sliderEl.getAttribute('data-slider-year')

          if (sliderYear === year) {
            sliderEl.classList.add('block')
            sliderEl.classList.remove('hidden')
          } else {
            sliderEl.classList.add('hidden')
            sliderEl.classList.remove('block')
          }

          // Trigger flickty rerender size
          // This doesn't work in Internet Explorer, where you'll have to do the longhand:
          // window.dispatchEvent(new Event('resize'));
          const resizeEvent = window.document.createEvent('UIEvents')
          resizeEvent.initUIEvent('resize', true, false, window, 0)
          window.dispatchEvent(resizeEvent)
        }
      })
    }
  },

  initFinancialReportAndPersonnelStructure: () => {
    const switchReportBtns = document.querySelectorAll('.switch-report-btn')
    const reports = document.querySelectorAll('[data-report-index]')

    for (const el of switchReportBtns) {
      const index = el.getAttribute('data-index')

      el.addEventListener('click', () => {
        for (const btnEl of switchReportBtns) {
          if (el.isEqualNode(btnEl)) {
            btnEl.classList.add('bg-gray-800')
            btnEl.classList.remove('bg-gray-700')
          } else {
            btnEl.classList.remove('bg-gray-800')
            btnEl.classList.add('bg-gray-700')
          }
        }

        for (const reportEl of reports) {
          const reportIndex = reportEl.getAttribute('data-report-index')

          if (reportIndex === index) {
            reportEl.classList.add('block')
            reportEl.classList.remove('hidden')
          } else {
            reportEl.classList.add('hidden')
            reportEl.classList.remove('block')
          }
        }
      })
    }
  }
}
